import React, {Component} from 'react';

import {t} from 'l10n';

import 'sass/not-found.scss';

export default function NotFound({history, staticContext}) {
    if (staticContext) {
        staticContext.notFound = true;
    }

    return (
        <div className="not-found-404">
            <div className="content">
                <p><strong>{t('Oops!')}</strong></p>

                <p>{t("The page you're looking for could not be found.")}</p>

                <p><a onClick={() => { if(history.length > 2) history.goBack(); else window.location.href="/"; } }>{t('Back to previous page')}</a></p>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/containers/NotFound.js